import React from "react";
import { usePlanGate } from "../../hooks/usePlanGate";
import { LockedFeatureCard } from "../LockedFeatureCard/LockedFeatureCard";

interface PlanGateProps {
  /** Clave de la feature gateada (FEATURE_GATES del backend). */
  feature: string;
  children: React.ReactNode;
}

/**
 * Envoltorio único de gating por plan en el frontend (spec 007):
 * `<PlanGate feature="comisiones">{módulo}</PlanGate>`.
 *
 * Si el plan del local no incluye la feature muestra la pantalla de bloqueo
 * vendedora; si la incluye (o no se pudo saber) renderiza el contenido. El
 * backend hace cumplir el gate con @RequirePlanFeature: esto es solo UX.
 */
export const PlanGate: React.FC<PlanGateProps> = ({ feature, children }) => {
  const gate = usePlanGate(feature);
  if (gate.locked) return <LockedFeatureCard feature={feature} />;
  return <>{children}</>;
};

export default PlanGate;
